import MenuSharpIcon from "@mui/icons-material/MenuSharp";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Tab from "@mui/material/Tab";
import { styled } from "@mui/material/styles";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import Loader from "./Loader";

import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import Backdrop from "@mui/material/Backdrop";
import Tooltip from "@mui/material/Tooltip";
import * as XLSX from "xlsx";
import { setSubmitData, submitData } from "../features/submitSlice";
import { getTargetScenario } from "../features/targetScenarioSlice";
import {
  clearWorkspaceData,
  getWorkSpaceData,
  getWorkSpaceDataSuccessCall,
  saveNetZeroPathwayData,
  setChangedMaterial,
  setMaterials,
  setRegion,
  setScenario,
  setWorkspaceData,
  updateWorkspaceData,
  workspaceSaveDataCall,
  setAssessmentId,
} from "../features/workspaceDataSlice";
import Header from "../header/Header";
import ChatIcon from "../images/Chat.png";
import SaveIcon from "../images/Save.png";
import UploadIcon from "../images/Upload.png";
import arrowIcon from "../images/arrow.png";
import CircularWithValueLabel from "./CircularProgressLabel";
import ConfirmationPopup from "./ConfirmationPopup";
import ErrorHandler from "./ErrorHandler";
import NetzeroPopup from "./NetzeroPopup";
import SnackbarHandler from "./Snackbar";
import SubmitReviewalPopup from "./SubmitReviewalPopup";
import WorkspaceTableHeader from "./WorkspaceTableHeader";
import PowerBiReports from "./PowerBi";

const Workspace = (props) => {
  const { targetScenario, error, success } = useSelector(
    (state) => state.targetScenario
  );

  const { newAssessmentData } = useSelector((state) => state.newAssessment);
  const { isNewAssessment } = useSelector((state) => state.flag);
  const [openPopup, setOpenPopup] = useState(false);
  const [openConfirmPopup, setOpenConfirmPopup] = useState(false);
  const [openSubmitRenewalPopup, setOpenSubmitRenewalPopup] = useState(false);
  const [openReviewalConfirmPopup, setOpenReviewalConfirmPopup] =
    useState(false);
  const [columnVisibility, setColumnVisibility] = useState("");
  const [edited, setEdited] = useState(false);

  const [showRightPanel, setShowRightPanel] = useState(true);
  const [popupData, setPopupData] = useState({
    carbonNeutral: false,
    designEfficiency: false,
    remainingCarbonEmission: "",
    climateActiveCertifiedProduct: "",
    materialQuantityReduction: "",
    type: "carbonRdcn",
  });
  const [value, setValue] = React.useState("Base");
  const [selectedLabel, setSelectedLabel] = useState("Base");

  const navigate = useNavigate();

  const [columnData, setcolumnData] = useState([]);
  const dispatch = useDispatch();

  const [clearAllData, setClearAllData] = useState({});
  const [clearClicked, setClearClicked] = useState(false);
  const [saveClicked, setSaveClicked] = useState(false);
  const { accessToken } = useSelector((state) => state.user);
  const {
    savedWorkspaceData,
    finalWorkspaceData,
    materials,
    region,
    changedMaterial,
    scenario,
    netZeroPathwayData,
    workspaceData,
    workspaceDataSaveSuccess,
    getWorkspaceDataLoading,
    getWorkspaceDataSuccess,
    popupWorkspaceDataSuccess,
    workspaceDataSaveLoading,
    workspaceDataSaveError,
  } = useSelector((state) => state.workspaceData);
  const { submitReviewalResponse } = useSelector((state) => state.submitData);
  const [showIframe, setShowIframe] = useState(false);
  let [checkRendered, setCheckRendered] = useState(0);
  const location = useLocation();
  const [filteredRowData, setFilteredRowData] = useState();
  const [newData, setNewData] = useState({
    material: "",
    building_elements: "",
    building_sub_elements: "",
    quantity: 0,
    product: "",
    subproduct: "",
    emission_intensity: "",
  });
  const [workspaceMaterials, setWorkspaceMaterials] = useState([]);
  const [selectedScenarioBox, setSelectedScenarioBox] = useState("");
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [filteredDataLoading, setFilteredDataLoading] = useState(true);
  const [allUnit, setAllUnit] = useState([]);  
  
  const endYear =
    Object.keys(newAssessmentData).length > 0 && isNewAssessment
      ? newAssessmentData.endDate && newAssessmentData.endDate.slice(6, 10)
      : workspaceData &&
        workspaceData.workspace_data &&
        workspaceData.workspace_data.project_attributes &&
        workspaceData.workspace_data.project_attributes.construction_end_date.slice(
          6,
          10
        );

  const regionLooker =
    Object.keys(newAssessmentData).length > 0 && isNewAssessment
      ? newAssessmentData.region && newAssessmentData.region
      : workspaceData &&
        workspaceData.workspace_data &&
        workspaceData.workspace_data.project_attributes &&
        workspaceData.workspace_data.project_attributes.region;

  const assessementId =
    Object.keys(newAssessmentData).length > 0 && isNewAssessment
      ? newAssessmentData.assessementId && newAssessmentData.assessementId
      : workspaceData && workspaceData.assessment_unique_id;

  const projectType =
    Object.keys(newAssessmentData).length > 0 && isNewAssessment
      ? newAssessmentData.projectType && newAssessmentData.projectType
      : workspaceData &&
        workspaceData.workspace_data &&
        workspaceData.workspace_data.project_attributes &&
        workspaceData.workspace_data.project_attributes.project_type;

  useEffect(() => {
    if (!isSubmitted && submitReviewalResponse) {
      if (submitReviewalResponse.response !== undefined) {
        if (submitReviewalResponse.response == 200) {
          setIsSubmitted(true);
          closeSubmitRenewalDialog();
          setOpenReviewalConfirmPopup(true);
        } else {
          return <ErrorHandler error={"Internal Server error"} />;
        }
      }
      dispatch(setSubmitData(null));
    }
  }, [submitReviewalResponse]);

  useEffect(() => {
    if (saveClicked && workspaceDataSaveSuccess) {
      const timeoutId = setTimeout(() => {
        setSaveClicked(false);
      }, 6000);

      return () => {
        clearTimeout(timeoutId);
      };
    }
  }, [workspaceDataSaveSuccess, saveClicked]);

  
  useEffect(() => {
    if (getWorkspaceDataSuccess && !isNewAssessment) {
      setShowIframe(false);
      setShowIframe(true);
    }
  }, [getWorkspaceDataSuccess]);
  useEffect(() => {
    if (workspaceDataSaveSuccess) {
      setShowIframe(false);
      setShowIframe(true);
    }
  }, [workspaceDataSaveSuccess]);
  useEffect(() => {
    if (selectedScenarioBox) {
      setShowIframe(false);
      setShowIframe(true);
    }
  }, [selectedScenarioBox]);

  const [projectName, setProjectName] = useState();
  const [emissionIntensityData, setEmissionIntensityData] = useState();
  const [initialRender, setInitialRender] = useState(false);

  const [pageload, setPageLoad] = useState(0);
  const [subProductListData, setSubProductListData] = useState();

  const dataRender = () => {
    if (savedWorkspaceData.length <= 0 && !isNewAssessment) {
      const assessmentId = sessionStorage.getItem("assessmentId");

      const data = {
        id: assessmentId,

        accessToken: accessToken,
      };
      if(assessmentId)
      {
      dispatch(getWorkSpaceData(data));
      }
    }
  };
  useEffect(() => {
    if (pageload == 0) {
      setPageLoad(pageload + 1);
      dataRender();
    }
  }, [pageload]);

  useEffect(() => {
    if (
      (getWorkspaceDataSuccess || popupWorkspaceDataSuccess) &&
      Object.keys(workspaceData.workspace_data).length > 0
    ) {
      setClearAllData(workspaceData);
      setInitialRender(true);
      const projectName =
        Object.keys(newAssessmentData).length > 0 && isNewAssessment
          ? newAssessmentData.projectName && newAssessmentData.projectName
          : workspaceData &&
            workspaceData.workspace_data &&
            workspaceData.workspace_data.project_attributes &&
            workspaceData.workspace_data.project_attributes.project_name;

      setProjectName(projectName);

      if (
        Object.keys(workspaceData.workspace_data.workspace_materials).length > 0
      ) {
        dispatch(
          saveNetZeroPathwayData(
            workspaceData.workspace_data.workspace_materials
          )
        );
      } else {
        dispatch(saveNetZeroPathwayData([]));
      }

      //setCheckRendered(checkRendered+1);
      const intensityData = workspaceData.workspace_data.emission_intensity;
      const emissionIntensityValues = [];
      const units = [];
      intensityData &&
        intensityData.forEach((row) => {
          let key = "";
          if (row.sub_product) {
            key = row.material + "_" + row.product + "_" + row.sub_product;
          } else {
            key = row.material + "_" + row.product;
          }
          emissionIntensityValues.push({
            key: key,
            value: row.emission_intensity_value + " kgCO2-eq/" + row.unit,
            unit: row.unit,
          });
          units.push(row.unit);
        });
      setAllUnit(Array.from(new Set(units)));
      setEmissionIntensityData(emissionIntensityValues);
      const subProductData = workspaceData.workspace_data.sub_product_dropdown;
      const subProductValues = [];
      subProductData &&
        subProductData.forEach((row) => {
          let key = "";
          key = row.material + "_" + row.product;
          subProductValues.push({
            key: key,
            value: row.sub_product_info.sub_product_list,
          });
        });

      setSubProductListData(subProductValues);

      const filtedMaterials =
        workspaceData.workspace_data.material_elements_subelements.map(
          (elements) => elements.material
        );
      const materialList = filtedMaterials;

      dispatch(setMaterials(materialList));

      /*const getRegion = workspaceData.workspace_data.product_dropdown.map(
        (elements) => elements.region
      );*/
      const getRegion = () => {
        if (workspaceData?.workspace_data.project_attributes?.region) {
          return workspaceData?.workspace_data.project_attributes?.region;
        } else {
          return newAssessmentData.region;
        }
      };

      const scenarioList = ["Base", "Moderate", "Stretch", "Innovation"];

      const inputValues =
        workspaceData.workspace_data &&
        workspaceData.workspace_data.input_values &&
        workspaceData.workspace_data.input_values.filter(
          (elements) =>
            materialList.includes(elements.material) &&
            scenarioList.includes(elements.case_name)
        );

      dispatch(setRegion(getRegion()));
      if (materialList.length > 0) {
        dispatch(setChangedMaterial(materialList[0]));
      }

      let result =
        workspaceData.workspace_data.material_elements_subelements.flatMap(
          (obj) => {
            return scenarioList.map((scenario) => {
              return { ...obj, scenario: scenario };
            });
          }
        );

      const subEle = [];
      result.flatMap((obj, index) => {
        return obj.elements.forEach((element, elementIndex) => {
          const subElements = element.building_sub_elements.map(
            (subElement) => {
              const { elements, ...newObj } = obj;

              return {
                ...newObj,
                id: `${index}-${element.building_elements}-${subElement}-${scenario}`,
                building_elements: element.building_elements,
                building_sub_elements: subElement,
              };
            }
          );

          subEle.push(...subElements);
        });
      });
      result = subEle;

      const initialResult = [];
      let previousBuildingElements = null;
      let previousScenario = null;
      result.forEach((item, i) => {
        const newUpdateItem = [];
        if (
          item.building_elements !== previousBuildingElements ||
          item.scenario !== previousScenario
        ) {
          let mainItem = {
            header: item.building_elements,

            id: item.scenario + "_" + item.building_elements,
            material: item.material,
            scenario: item.scenario,
            //building_sub_elements: ""
          };

          newUpdateItem.push(mainItem);
        }
        previousBuildingElements = item.building_elements;
        previousScenario = item.scenario;

        inputValues &&
          inputValues.forEach((productItem, ind) => {
            if (
              productItem.material === item.material &&
              productItem.case_name === item.scenario &&
              productItem.building_element === item.building_elements &&
              productItem.building_sub_element === item.building_sub_elements
            ) {
              const eachGradeValue = productItem.default_rows.map(
                (row, index) => ({
                  ...item,
                  quantity: row.quantity,
                  product: row.default_product,
                  subproduct: row.default_sub_product,
                  subproductExists:
                    row.default_sub_product != null &&
                    row.default_sub_product != "" &&
                    row.default_sub_product != "undefined" &&
                    true,
                  emission_intensity: row.default_emission_intensity,
                  row_index: row.row_index,
                  header: index === 0 ? productItem.building_sub_element : "",
                  material: productItem.material,
                  unit: row.default_product_unit,
                  //scenario: productItem.case_name,
                  building_elements: productItem.building_element,
                  building_sub_elements: productItem.building_sub_element,
                  id:
                    item.scenario +
                    "_" +
                    i +
                    "_" +
                    item.material +
                    "_" +
                    item.building_elements +
                    "_" +
                    item.building_sub_elements +
                    "_" +
                    index +
                    "_" +
                    ind,
                })
              );

              newUpdateItem.push(...eachGradeValue);
            }
          });

        initialResult.push(...newUpdateItem);
      });

      result = initialResult;

      dispatch(setWorkspaceData(result));

      const netzeroScenarios = () => {
        if (getRegion() === "AU" || getRegion() === "Australia") {
          return ["Moderate", "Stretch", "Innovation"];
        } else {
          return ["Stretch", "Innovation"];
        }
      };
      const netzeroScenarioList = netzeroScenarios();
      let changedNetzeroData = [];

      if (workspaceData.workspace_data.workspace_materials.length == 0) {
        const initialMappedNetzeroData = materialList.flatMap((material) => {
          return netzeroScenarioList.map((scenario) => {
            return {
              scenario: scenario,
              carbon_neutral_selection: 0,
              design_efficiency_selection: 0,
              remaining_carbon_emission: 0,
              climate_active_certified_product: 0,
              material_quantity_reduction: 0,
              material: material,
            };
          });
        });

        dispatch(saveNetZeroPathwayData(initialMappedNetzeroData));
        changedNetzeroData = initialMappedNetzeroData;
      } else {
        changedNetzeroData = netZeroPathwayData;
      }

      const assessment_id = workspaceData?.assessment_unique_id;

      const newData = result
        .filter(
          (element) =>
            element.building_sub_elements !== "" && element.quantity > 0
        )
        .map(({ header, id, subproductExists, ...rest }) => rest);

      const savedItems = {
        assessment_id: assessment_id,
        workspace_products: newData,
        workspace_materials: changedNetzeroData,
      };

      {
        popupWorkspaceDataSuccess &&
          dispatch(workspaceSaveDataCall({ accessToken, savedItems }));
      }
    }
    // return () => {

    //   setCheckRendered(checkRendered+1);

    // }
  }, [getWorkspaceDataSuccess, popupWorkspaceDataSuccess]);

  useEffect(() => {
    setPopupData(popupData);
  }, [popupData]);

  useEffect(() => {
    setValue(scenario);
    updateNetzeroPopupData(scenario, changedMaterial);
    setClearClicked(false);
  }, [scenario, changedMaterial, clearClicked]);
  useEffect(() => {
    setSelectedLabel(value);
    dispatch(setScenario(value));
  }, [value]);

  const loadData = async () => {
    try {
      setFilteredDataLoading(true);
      await new Promise((resolve) => setTimeout(resolve, 2000));

      const rowData = savedWorkspaceData.filter(
        (item) =>
          item.material === changedMaterial && item.scenario === scenario
      );
      const newUpdateItem = [];

      rowData.forEach((item, i) => {
        if (i === 0) {
          const mainItem = {
            header: item.building_elements,
            id:
              item.scenario +
              "_" +
              item.building_elements +
              "_" +
              item.material +
              "_" +
              i,
            // building_sub_elements: "",
            building_elements: item.building_elements,
          };

          newUpdateItem.push(mainItem);
        }
      });

      newUpdateItem.push(...rowData);

      setFilteredRowData(newUpdateItem);

      const subProduct = newUpdateItem.filter(
        (element) =>
          ((element.subproduct !== null &&
            element.subproduct !== "" &&
            element.subproduct !== "undefined") ||
            element.subproductExists) &&
          element.hasOwnProperty("building_elements")
      );

      subProduct.length > 1
        ? setColumnVisibility({ subproduct: true })
        : setColumnVisibility({ subproduct: false });
    } catch (error) {
      console.error(error);
    } finally {
      setFilteredDataLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, [changedMaterial, scenario, clearClicked, initialRender, pageload]);

  useEffect(() => {
    if (savedWorkspaceData.length > 0) {
      const productLists = workspaceData.workspace_data.product_dropdown.find(
        (item) =>
          item.material === changedMaterial && item.case_name === scenario
      )?.product_info.product_list;
      const subProductList =
        workspaceData.workspace_data.sub_product_dropdown.find(
          (item) =>
            item.material === changedMaterial && item.case_name === scenario
        )?.sub_product_info.sub_product_list;

      const csvData = workspaceData.workspace_data?.csv_data;

      const DynamicColumns = [
        {
          field: "header",
          disableSort: true,
          headerName:
            filteredRowData && filteredRowData.length > 0
              ? filteredRowData[1].header
              : "",
          flex: 1,
          colSpan: ({ row }) => {
            if (!row.hasOwnProperty("building_sub_elements")) {
              return 5;
            }
            return undefined;
          },
          valueGetter: ({ value, row }) => {
            if (row.building_sub_elements == "") {
              return row.building_elements;
            }
            return value;
          },
        },
        {
          field: "quantity",
          disableSort: true,
          renderCell: (params) => (
            <div
              style={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                width: "100%",
              }}
            >
              <input
                type="text"
                value={params.value}
                onChange={(event) => {
                  const newValue = event.target.value;
                  params.api.setEditCellValue({
                    id: params.id,
                    field: params.field,
                    value: newValue,
                  });
                }}
                class="MuiDataGrid-cellContent"
                style={{
                  paddingRight: "2rem",
                  padding: "0px 10px",
                  outline: "none",
                  height: "45px",
                  width: "100%",
                  fontFamily: "DMSansRegular",
                  color: "#64748b",
                  fontSize: "1rem",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  right: "0.5rem",
                  color: "#64748b",
                  fontFamily: "DMSansRegular",
                  fontSize: "1rem",
                }}
              >
                {params.row.unit}
              </div>
            </div>
          ),
          valueGetter: (params) => {
            if (csvData && csvData.length > 0) {
              const item = csvData.find(
                (element) =>
                  element["Building Sub-Element"] ==
                    params.row.building_sub_elements &&
                  element["Type/Grade"] == params.row.product
              );
              if (item) {
                return item["Quantities"];
              } else {
                return params.value;
              }
            } else {
              return params.value;
            }
          },
          headerName: "Quantity",
          flex: 1,
          editable: true,
        },
        {
          field: "product",
          disableSort: true,
          headerName: "Product",
          flex: 1,
          type: "singleSelect",
          valueOptions: productLists,
          editable: scenario !== "Base" ? true : false,
        },
        {
          field: "subproduct",
          disableSort: true,
          headerName: "Sub Product",
          flex: 1,
          type: "singleSelect",
          valueOptions: (params) => {
            return getSubProductList(
              `${params.row.material}_${params.row.product}`
            );
          },
          editable: scenario !== "Base" ? true : false,
        },
        {
          field: "emission_intensity",
          disableSort: true,
          headerName: "Emission Intensity",
          flex: 1,
          valueGetter: (params) => {
            const emissionValue = params.value;
            if (
              typeof emissionValue == "string" &&
              emissionValue.includes("kgCO2-eq/")
            ) {
              return emissionValue;
            } else {
              const unit = params.row.unit;
              return params.value ? params.value + " kgCO2-eq/" + unit : 0;
            }
          },
        },
      ];

      setcolumnData(DynamicColumns);
    }
  }, [filteredRowData]);

  // useEffect(() => {
  //   console.log("Access token",accessToken)
  //   const fetchAccessTokenPowerBi = async () => {
  //     try {
  
  //       const token = await getAccessTokenForPowerBI(); // Call the function to get the access token
  //       setAccessTokenPowerBi(token);
  //       console.log(token) // Set the obtained token in state
  //     } catch (error) {
  //       console.error("Error obtaining access token:", error);
  //     }
  //   };
  
  //   fetchAccessTokenPowerBi(); // Invoke the function
  // }, []);  

  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  }));
  const CustomNoRowsOverlay = () => {
    return (
      <StyledGridOverlay>
        <Box sx={{ mt: 1 }}>No Data Available</Box>
      </StyledGridOverlay>
    );
  };

  const openDialog = (e) => {
    if (e.currentTarget.name === "carbonNeutral") {
      setOpenPopup(true);
      const updatedData = { ...popupData };
      updatedData.carbonNeutral = true;
      updatedData.type = "carbonRdcn";
      setPopupData(updatedData);
    } else if (e.currentTarget.name === "designEfficiency") {
      setOpenPopup(true);
      const updatedData = { ...popupData };
      updatedData.designEfficiency = true;
      updatedData.type = "designEffcy";
      setPopupData(updatedData);
    } else if (e.currentTarget.name === "submitRenewal") {
      const data = {
        id: workspaceData?.assessment_unique_id,
        targetScenario: selectedScenarioBox,
        accessToken: accessToken,
      };
      dispatch(getTargetScenario(data));
      setOpenSubmitRenewalPopup(true);
    } else if (e.currentTarget.name === "editBtn") {
      setOpenConfirmPopup(true);
    }
    dispatch(getWorkSpaceDataSuccessCall());
  };

  const closeDialog = (type) => {
    if (type === "save" && popupData.type === "carbonRdcn") {
      const updatedData = { ...popupData };
      updatedData.carbonNeutral = true;
      setPopupData(updatedData);
      setOpenPopup(false);
      return;
    }
    if (type === "save" && popupData.type === "designEffcy") {
      const updatedData = { ...popupData };
      updatedData.designEfficiency = true;
      setPopupData(updatedData);
      setOpenPopup(false);
      return;
    }
    setOpenPopup(false);
  };

  const closeSubmitRenewalDialog = () => {
    setOpenSubmitRenewalPopup(false);
  };

  const closeConfirmDialog = () => {
    setOpenConfirmPopup(false);
  };

  const closeReviewalConfirmDialog = () => {
    setOpenReviewalConfirmPopup(false);
  };

  const toggleRightPanel = () => {
    setShowRightPanel(!showRightPanel);
  };

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
    updateNetzeroPopupData(newValue, changedMaterial);
  };

  const updateNetzeroPopupData = (newValue, mtrl) => {
    const existData = netZeroPathwayData.find(
      (obj) => obj.scenario === newValue && obj.material === mtrl
    );
    if (existData) {
      const updatedData = { ...popupData };
      updatedData.carbonNeutral =
        existData.carbon_neutral_selection == 1 ? true : false;
      updatedData.designEfficiency =
        existData.design_efficiency_selection == 1 ? true : false;
      updatedData.remainingCarbonEmission = existData.remaining_carbon_emission;
      updatedData.climateActiveCertifiedProduct =
        existData.climate_active_certified_product;
      updatedData.materialQuantityReduction =
        existData.material_quantity_reduction;
      setPopupData(updatedData);
    } else {
      const updatedData = { ...popupData };
      updatedData.carbonNeutral = false;
      updatedData.designEfficiency = false;
      updatedData.remainingCarbonEmission = "";
      updatedData.climateActiveCertifiedProduct = "";
      updatedData.materialQuantityReduction = "";
      setPopupData(updatedData);
    }
  };

  const saveHandler = () => {
    setSaveClicked(true);
    setShowIframe(false);
    const newData = savedWorkspaceData
      .filter(
        (element) =>
          element.building_sub_elements !== "" && element.quantity > 0
      )
      .map(({ header, id, emission_intensity, subproductExists, ...rest }) => {
        const emissionIntensityValue = parseFloat(emission_intensity);
        return {
          ...rest,
          emission_intensity: emissionIntensityValue,
        };
      });

    const finalData = newData;
    const savedData = [];
    const assessment_id = workspaceData?.assessment_unique_id;
    const savedItems = {
      assessment_id: assessment_id,
      workspace_products: finalData,
      workspace_materials: netZeroPathwayData,
    };

    dispatch(workspaceSaveDataCall({ accessToken, savedItems }));
    newData.find((item) => {
      let newItem = {};
      const rowId = item.id;
      savedData.push(newItem);
    });
  };
  const changeColumnEditable = () => {
    const colName = ["product", "subproduct"];
    const newcolumnData = columnData.map((obj) => {
      if (colName.includes(obj.field)) {
        return { ...obj, editable: true };
      }

      return obj;
    });
    setcolumnData(newcolumnData);
    closeConfirmDialog();
  };
  const handleCellKeyDown = (params, event) => {
    const key = event.key;
    const isNumericKey = /^\d$/.test(key);
    const isDecimalPoint = key === ".";
    const enteredValue = event.target.value || "";
    const hasDecimalPoint = enteredValue.includes(".");
    const isBackspace = key === "Backspace";

    if (!isNumericKey && !isDecimalPoint && !isBackspace) {
      event.preventDefault();
    } else if (isDecimalPoint && hasDecimalPoint) {
      event.preventDefault();
    } else if (hasDecimalPoint && !isBackspace) {
      const decimalIndex = enteredValue.indexOf(".");
      const decimalDigits = enteredValue.slice(decimalIndex + 1);
      if (decimalDigits.length >= 2) {
        event.preventDefault();
      }
    }
  };

  const processRowUpdate = (newRow) => {
    setEdited(true);
    const rowId = newRow.id;
    const updatedObj = savedWorkspaceData.map((obj) => {
      if (obj.id === rowId) {
        return newRow;
      }
      return obj;
    });

    let rowNewId = "";
    if (newRow.subproduct) {
      rowNewId =
        newRow.material + "_" + newRow.product + "_" + newRow.subproduct;
    } else {
      rowNewId = newRow.material + "_" + newRow.product;
    }

    const matchedData = calculateEmissionIntensity(rowNewId);
    let qty = 0;
    if (typeof newRow.quantity == "string" && newRow.quantity == "") {
      qty = 0;
    } else {
      qty = newRow.quantity;
    }
    if (matchedData.length > 0) {
      newRow = {
        ...newRow,
        emission_intensity: matchedData[0],
        quantity: qty == 0 ? 0 : qty,
        unit: matchedData[1],
      };
    }
    const updatedData = newRow;

    dispatch(updateWorkspaceData({ rowId, updatedData }));
    return newRow;
  };

  const calculateEmissionIntensity = (rowNewId) => {
    const matchedData = [];
    for (let i = 0; i < emissionIntensityData.length; i++) {
      if (
        emissionIntensityData[i].key == rowNewId &&
        emissionIntensityData[i].key !== "undefined"
      ) {
        matchedData.push(emissionIntensityData[i].value);
        matchedData.push(emissionIntensityData[i].unit);
      }
    }

    return matchedData;
  };
  const getSubProductList = (key) => {
    if (subProductListData) {
      const lists = subProductListData.find((list) => list.key == key)?.value;
      return lists;
    }
  };
  const submitForReviewal = (targetOption, submitReviewalData) => {
    setIsSubmitted(false);
    const assessment_id = workspaceData?.assessment_unique_id;
    const data = {
      //  id: "zuT8P09kdPt8cIeSKpiS",
      id: assessment_id,
      targetScenario: targetOption,
      accessToken: accessToken,
      submitData: {
        ...submitReviewalData,
      },
    };
    dispatch(submitData(data));
  };

  const goToHome = () => {
    setOpenReviewalConfirmPopup(false);
    navigate("/home");
  };

  const getCellClassName = ({ row, field }) => {
    if (!row.hasOwnProperty("building_sub_elements")) {
      if (field === "header") {
        return "bold";
      }
    }
    return "";
  };

  const clearData = () => {
    setClearClicked(true);
    dispatch(
      clearWorkspaceData({ material: changedMaterial, scenario: scenario })
    );
  };

  const exportAsExcel = () => {
    const data = {};
    savedWorkspaceData.forEach((item) => {
      if (!item.hasOwnProperty("building_elements")) return;
      const { material, scenario, quantity, product, subproduct, unit } = item;
      if (!data[material]) {
        data[material] = {};
      }

      if (!data[material][scenario]) {
        data[material][scenario] = [];
      }

      if (subproduct) {
        data[material][scenario].push({
          type: product + "_" + subproduct,
          quantity: quantity,
          unit: unit,
        });
      } else {
        data[material][scenario].push({
          type: product,
          quantity: quantity,
          unit: unit,
        });
      }
    });
    const workbook = XLSX.utils.book_new();
    const worksheetData = [
      [
        "Category",
        "Material Type",
        "Product and Sub-product",
        "Quantity",
        "Unit",
      ],
    ];
    Object.keys(data).forEach((categoryName) => {
      const category = data[categoryName];

      Object.keys(category).forEach((subcategoryName) => {
        if (
          subcategoryName === "Base" ||
          subcategoryName === "Moderate" ||
          subcategoryName === "Stretch" ||
          subcategoryName === "Innovation"
        ) {
          const subcategoryData = category[subcategoryName];
          worksheetData.push([categoryName, subcategoryName, "", ""]);

          subcategoryData.forEach((row) => {
            worksheetData.push(["", "", row.type, row.quantity, row.unit]);
          });
        }
      });
    });
    const projectAttributes = workspaceData.workspace_data.project_attributes;
    let projectName,
      region,
      address,
      projectManager,
      businessUnit,
      contractType;
    let projectType, structuralDesignOptions, structuralHeight, startData;
    let endDate, projectTarget, formattedDate;
    if (workspaceData.workspace_data.hasOwnProperty("project_attributes")) {
      projectName = projectAttributes.project_name;
      region = projectAttributes.region;
      address = projectAttributes.address;
      projectManager = projectAttributes.project_manager;
      businessUnit = projectAttributes.business_unit
        ? projectAttributes.business_unit
        : "";
      const contractType = projectAttributes.contract_type
        ? projectAttributes.contract_type
        : "";
      projectType = projectAttributes.project_type;
      structuralDesignOptions = projectAttributes.structural_design_options;
      structuralHeight = projectAttributes.structural_height;
      startData = projectAttributes.construction_start_date;
      endDate = projectAttributes.construction_end_date;
      projectTarget =
        projectAttributes.building_area +
        " " +
        projectAttributes.building_area_uom;
      const lastUpdated = projectAttributes.last_updated;
      formattedDate = new Date(lastUpdated).toLocaleString();
    } else {
      projectName = newAssessmentData.projectName;
      region = newAssessmentData.region;
      address = newAssessmentData.address;
      projectManager = newAssessmentData.projectManager;
      businessUnit = newAssessmentData.businessUnit;
      contractType = newAssessmentData.contractType;
      projectType = newAssessmentData.projectType;
      structuralDesignOptions = newAssessmentData.structural_design_options;
      structuralHeight = newAssessmentData.structural_height;
      startData = newAssessmentData.startData;
      endDate = newAssessmentData.endDate;
      const buildingAreaUnit =
        newAssessmentData.region === "United States" ? "ft2" : "m2";
      projectTarget = newAssessmentData.buildingArea + " " + buildingAreaUnit;
    }
    const sheet2Data = [
      ["Project Name", projectName],
      ["Region ", region],
      ["Address ", address],
      ["Project Manager ", projectManager],
      ["Business Unit", businessUnit],
      ["Contract Type", contractType],
      ["Typologies", projectType],
      ["Structural Design Options", structuralDesignOptions],
      ["Structural height", structuralHeight],
      ["Construction Start /End Date", startData + " , " + endDate],
      ["GFA/GIA", projectTarget],
      ["Date", formattedDate],
    ];
    const testSheet = XLSX.utils.aoa_to_sheet(sheet2Data);
    XLSX.utils.book_append_sheet(
      workbook,
      testSheet,
      "Project Attributes Output"
    );

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Building Materials Output"
    );

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const dataBlob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });
    const fileName = "exported_output.xlsx";
    const downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(dataBlob);
    downloadLink.download = fileName;
    downloadLink.click();
  };

  // new export as excel
  // const exportAsExcel = () => {
  //   const data = [];
  //   savedWorkspaceData.forEach((item) => {
  //     if (item.material) {
  //       const itemRow = {
  //         material: item.material,
  //         scenario: item.scenario,
  //         type:
  //           item.subproduct == null
  //             ? item.product
  //             : item.product + "_" + item.subproduct,
  //         quantity: item.quantity > 0 ? item.quantity : 1000,
  //       };
  //       data.push(itemRow);
  //     }
  //   });

  //   const headers = ["Material", "Base", "Moderate", "Stretch", "Innovation"];
  //   const mergedData = {};

  //   data.forEach((item) => {
  //     const { material, scenario, type, quantity } = item;
  //     if (!mergedData[material]) {
  //       mergedData[material] = {
  //         Base: "",
  //         Moderate: "",
  //         Stretch: "",
  //         Innovation: "",
  //       };
  //     }
  //     mergedData[material][scenario] =
  //       mergedData[material][scenario] + `${type} , ${quantity}\n`;
  //   });

  //   const flattenedData = Object.entries(mergedData).map(
  //     ([material, rowData]) => [
  //       material,
  //       rowData.Base.trim(),
  //       rowData.Moderate.trim(),
  //       rowData.Stretch.trim(),
  //       rowData.Innovation.trim(),
  //     ]
  //   );

  //   const worksheetData = [headers, ...flattenedData];
  //   const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

  //   const columnWidths = [5, 5, 5, 5, 5];
  //   worksheet["!cols"] = columnWidths.map((width) => ({ width: width * 7 }));

  //   const sheet2Data = [
  //     ["Project Name", newAssessmentData.projectName],
  //     ["Region ", newAssessmentData.region],
  //     ["Address ", newAssessmentData.address],
  //     ["Project Manager ", newAssessmentData.projectManager],
  //     ["Business Unit", newAssessmentData.businessUnit],
  //     ["Contract Type", newAssessmentData.contractType],
  //     ["Typologies", newAssessmentData.projectType],
  //     [
  //       "Structural Design Options",
  //       newAssessmentData.structural_design_options,
  //     ],
  //     ["Structural height", newAssessmentData.structural_height],
  //     [
  //       "Construction Start /End Date",
  //       newAssessmentData.startData + " , " + newAssessmentData.endDate,
  //     ],
  //     ["GFA/GIA", newAssessmentData.projectTarget],
  //   ];
  //   const worksheet2 = XLSX.utils.aoa_to_sheet(sheet2Data);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(
  //     workbook,
  //     worksheet2,
  //     "Project Attributes Output"
  //   );
  //   XLSX.utils.book_append_sheet(
  //     workbook,
  //     worksheet,
  //     "Building Materials Output"
  //   );
  //   const excelFile = XLSX.write(workbook, {
  //     bookType: "xlsx",
  //     type: "binary",
  //   });

  //   const buffer = new ArrayBuffer(excelFile.length);
  //   const view = new Uint8Array(buffer);
  //   for (let i = 0; i < excelFile.length; i++) {
  //     view[i] = excelFile.charCodeAt(i) & 0xff;
  //   }
  //   const blob = new Blob([buffer], { type: "application/octet-stream" });
  //   saveAs(blob, "exported_output.xlsx");
  // };

  const handleScenarioBoxClick = (e) => {
    setSelectedScenarioBox(e.currentTarget.id);
    setSubmitBtnDisabled(true);
  };

  const getGridWidth = () => {
    return "100%";
  };

  const CustomHeader = (column) => {
    return <div>{column.headerName}</div>;
  };

  return (
    <>
      <Container maxWidth="xl" style={{ padding: "0px" }}>
        <Header workspace="workspace" edited={edited} />
        <div class="assessment-menu">
          <div class="title">{projectName}</div>
          <div class="action-items">
            {/* <Tooltip title="Targeted For Future Release">
            <div>
                <img src={editIcon} alt="Edit Details" />
                <span>Edit Details</span>        
            </div>
          </Tooltip> */}
            <div onClick={saveHandler}>
              <img src={SaveIcon} alt="Save" />
              <span>Save</span>
            </div>
            <div onClick={exportAsExcel}>
              <img src={UploadIcon} alt="Export As" />
              <span>Export As</span>
            </div>
            <Tooltip title="Targeted For Future Release">
              <div>
                <img src={ChatIcon} alt="Comment" />
                <span>Comment</span>
              </div>
            </Tooltip>
            <button
              type="button"
              // class={`btn btn-primary submit-btn ${
              //   submitBtnDisabled ? "disable" : ""
              // }`}
              class={"btn btn-primary submit-btn disable"}
              name="submitRenewal"
              // onClick={openDialog}
              title="Targeted For Future Release"
            >
              Submit for reviewal
            </button>
            {showRightPanel ? (
              <Button
                variant="outlined"
                onClick={toggleRightPanel}
                startIcon={<MenuSharpIcon />}
              >
                {" "}
              </Button>
            ) : (
              ""
            )}
          </div>
        </div>

        <Box style={{ padding: "0px 50px" }}>
          <Grid
            container
            spacing={1}
            className={
              !showRightPanel
                ? "workspace-container"
                : " full-width workspace-container"
            }
          >
            <Grid item className="shadow-box left-container">
              <Box sx={{ width: "100%", typography: "body1" }}>
                <TabContext value={value}>
                  <Box sx={{}}>
                    <TabList
                      onChange={handleTabChange}
                      aria-label="lab API tabs example"
                      value={value}
                    >
                      <Tab label="Base" value="Base" />
                      <Tab label="Moderate" value="Moderate" />
                      <Tab label="Stretch" value="Stretch" />
                      <Tab label="Innovation" value="Innovation" />
                    </TabList>
                  </Box>
                  <TabPanel value="Base">
                    <Box sx={{ width: "100%" }}>
                      <WorkspaceTableHeader
                        openDialog={openDialog}
                        clearAllData={clearData}
                        popupData={popupData}
                        updateNetzeroPopupData={updateNetzeroPopupData}
                      />

                      <Box width={getGridWidth}>
                        {filteredDataLoading ? (
                          <Loader />
                        ) : (
                          <DataGrid
                            autoHeight
                            disableColumnFilter
                            disableRowSelectionOnClick
                            hideFooter
                            showCellVerticalBorder
                            showColumnVerticalBorder
                            onCellKeyDown={handleCellKeyDown}
                            columnVisibilityModel={columnVisibility}
                            columns={columnData.map((column) => ({
                              ...column,
                              headerComponent: CustomHeader,
                              disableClickEventBubbling: true,
                              sortable: false,
                            }))}
                            rows={
                              filteredRowData
                                ? filteredRowData
                                : savedWorkspaceData
                            }
                            processRowUpdate={processRowUpdate}
                            getCellClassName={getCellClassName}
                            loading={getWorkspaceDataLoading}
                            slots={{
                              noRowsOverlay: CustomNoRowsOverlay,
                            }}
                            components={{
                              LoadingOverlay: Loader,
                            }}
                            renderLoadingOverlay={() => <Loader />}
                          />
                        )}
                      </Box>
                    </Box>
                  </TabPanel>
                  <TabPanel value="Moderate">
                    <Box sx={{ width: "100%" }}>
                      <WorkspaceTableHeader
                        openDialog={openDialog}
                        clearAllData={clearData}
                        popupData={popupData}
                        updateNetzeroPopupData={updateNetzeroPopupData}
                      />
                      <Box width={getGridWidth}>
                        {filteredDataLoading ? (
                          <Loader />
                        ) : (
                          <DataGrid
                            autoHeight
                            disableColumnFilter
                            disableRowSelectionOnClick
                            hideFooter
                            showCellVerticalBorder
                            showColumnVerticalBorder
                            onCellKeyDown={handleCellKeyDown}
                            columnVisibilityModel={columnVisibility}
                            columns={columnData.map((column) => ({
                              ...column,
                              headerComponent: CustomHeader,
                              disableClickEventBubbling: true,
                              sortable: false,
                            }))}
                            rows={
                              filteredRowData
                                ? filteredRowData
                                : savedWorkspaceData
                            }
                            processRowUpdate={processRowUpdate}
                            getCellClassName={getCellClassName}
                            loading={getWorkspaceDataLoading}
                            slots={{
                              noRowsOverlay: CustomNoRowsOverlay,
                            }}
                            components={{
                              LoadingOverlay: Loader,
                            }}
                            renderLoadingOverlay={() => <Loader />}
                          />
                        )}
                      </Box>
                    </Box>
                  </TabPanel>
                  <TabPanel value="Stretch">
                    <Box sx={{ width: "100%" }}>
                      <WorkspaceTableHeader
                        openDialog={openDialog}
                        clearAllData={clearData}
                        popupData={popupData}
                        updateNetzeroPopupData={updateNetzeroPopupData}
                      />
                      <Box width={getGridWidth}>
                        {filteredDataLoading ? (
                          <Loader />
                        ) : (
                          <DataGrid
                            autoHeight
                            disableColumnFilter
                            disableRowSelectionOnClick
                            hideFooter
                            showCellVerticalBorder
                            showColumnVerticalBorder
                            onCellKeyDown={handleCellKeyDown}
                            columnVisibilityModel={columnVisibility}
                            columns={columnData.map((column) => ({
                              ...column,
                              headerComponent: CustomHeader,
                              disableClickEventBubbling: true,
                              sortable: false,
                            }))}
                            rows={
                              filteredRowData
                                ? filteredRowData
                                : savedWorkspaceData
                            }
                            processRowUpdate={processRowUpdate}
                            getCellClassName={getCellClassName}
                            loading={getWorkspaceDataLoading}
                            slots={{
                              noRowsOverlay: CustomNoRowsOverlay,
                            }}
                            components={{
                              LoadingOverlay: Loader,
                            }}
                            renderLoadingOverlay={() => <Loader />}
                          />
                        )}
                      </Box>
                    </Box>
                  </TabPanel>
                  <TabPanel value="Innovation">
                    <Box sx={{ width: "100%" }}>
                      <WorkspaceTableHeader
                        openDialog={openDialog}
                        clearAllData={clearData}
                        popupData={popupData}
                        updateNetzeroPopupData={updateNetzeroPopupData}
                      />
                      <Box width={getGridWidth}>
                        {filteredDataLoading ? (
                          <Loader />
                        ) : (
                          <DataGrid
                            autoHeight
                            disableColumnFilter
                            disableRowSelectionOnClick
                            hideFooter
                            showCellVerticalBorder
                            showColumnVerticalBorder
                            onCellKeyDown={handleCellKeyDown}
                            columnVisibilityModel={columnVisibility}
                            columns={columnData.map((column) => ({
                              ...column,
                              headerComponent: CustomHeader,
                              disableClickEventBubbling: true,
                              sortable: false,
                            }))}
                            rows={
                              filteredRowData
                                ? filteredRowData
                                : savedWorkspaceData
                            }
                            processRowUpdate={processRowUpdate}
                            getCellClassName={getCellClassName}
                            loading={getWorkspaceDataLoading}
                            slots={{
                              noRowsOverlay: CustomNoRowsOverlay,
                            }}
                            components={{
                              LoadingOverlay: Loader,
                            }}
                            renderLoadingOverlay={() => <Loader />}
                          />
                        )}
                      </Box>
                    </Box>
                  </TabPanel>
                </TabContext>
              </Box>
            </Grid>
            <Grid item className="shadow-box right-container">
              <Button
                class="arrow-btn"
                variant="outlined"
                onClick={toggleRightPanel}
              >
                {" "}
                <img src={arrowIcon} alt="RigthArrow" />
              </Button>
              <Box className="shadow-box content-box">
                <div className="label1">
                  Select <span>Building</span> Target Scenario
                </div>
                <div className="label2">
                  Select the target scenario before submission.
                  <div>Data reflects below upon "Save"</div>
                </div>
                <Box className="scenario-list">
                  <Box
                    id="Base"
                    className={selectedScenarioBox === "Base" ? "active" : ""}
                    onClick={handleScenarioBoxClick}
                  >
                    <div className="scenario" title="Base">
                      Base
                    </div>
                    <div className="value">
                      {finalWorkspaceData.length !== 0
                        ? finalWorkspaceData.Base && finalWorkspaceData.Base
                        : workspaceData &&
                          workspaceData.workspace_data &&
                          workspaceData.workspace_data.project_attributes &&
                          workspaceData.workspace_data.project_attributes
                            .base_emission}
                    </div>
                    <div className="label">
                      kgCO2-eq/{regionLooker === "United States" ? "ft2" : "m2"}
                    </div>
                  </Box>
                  <Box
                    id="Moderate"
                    className={
                      selectedScenarioBox === "Moderate" ? "active" : ""
                    }
                    onClick={handleScenarioBoxClick}
                  >
                    <div className="scenario" title="Moderate">
                      Moderate
                    </div>
                    <div className="value">
                      {finalWorkspaceData.length !== 0
                        ? finalWorkspaceData.Moderate &&
                          finalWorkspaceData.Moderate
                        : workspaceData &&
                          workspaceData.workspace_data &&
                          workspaceData.workspace_data.project_attributes &&
                          workspaceData.workspace_data.project_attributes
                            .moderate_emission}
                    </div>
                    <div className="label">
                      kgCO2-eq/{regionLooker === "United States" ? "ft2" : "m2"}
                    </div>
                  </Box>
                  <Box
                    id="Stretch"
                    className={
                      selectedScenarioBox === "Stretch" ? "active" : ""
                    }
                    onClick={handleScenarioBoxClick}
                  >
                    <div className="scenario" title="Stretch">
                      Stretch
                    </div>
                    <div className="value">
                      {finalWorkspaceData.length !== 0
                        ? finalWorkspaceData.Stretch &&
                          finalWorkspaceData.Stretch
                        : workspaceData &&
                          workspaceData.workspace_data &&
                          workspaceData.workspace_data.project_attributes &&
                          workspaceData.workspace_data.project_attributes
                            .stretch_emission}
                    </div>
                    <div className="label">
                      kgCO2-eq/{regionLooker === "United States" ? "ft2" : "m2"}
                    </div>
                  </Box>
                  <Box
                    id="Innovation"
                    className={
                      selectedScenarioBox === "Innovation" ? "active" : ""
                    }
                    onClick={handleScenarioBoxClick}
                  >
                    <div className="scenario" title="Innovation">
                      Innovation
                    </div>
                    <div className="value">
                      {finalWorkspaceData.length !== 0
                        ? finalWorkspaceData.Innovation &&
                          finalWorkspaceData.Innovation
                        : workspaceData &&
                          workspaceData.workspace_data &&
                          workspaceData.workspace_data.project_attributes &&
                          workspaceData.workspace_data.project_attributes
                            .innovation_emission}
                    </div>
                    <div className="label">
                      kgCO2-eq/{regionLooker === "United States" ? "ft2" : "m2"}
                    </div>
                  </Box>
                </Box>
              </Box>
              <div className="label3">
                <div>Click download button to download the graphs</div>
                <ArrowDownwardIcon />
              </div>

              <Box className="shadow-box looker-box">
                {showIframe && (
                  <PowerBiReports 
                  region={regionLooker} 
                  assessementId={assessementId} 
                  selectedScenario={selectedScenarioBox && selectedScenarioBox}
                  projectName={projectName}
                />
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>

        <NetzeroPopup
          title={"Material"}
          material={"Concrete"}
          scenario={selectedLabel}
          data={workspaceMaterials}
          savedWorkspaceData={savedWorkspaceData}
          openPopup={openPopup}
          setClosePopup={closeDialog}
          setOpenPopup={setOpenPopup}
          popupData={popupData}
          loadData={loadData}
        />
        <SubmitReviewalPopup
          title={"Submit for reviewal"}
          targetSelection={selectedScenarioBox}
          successCallbackFn={submitForReviewal}
          openPopup={openSubmitRenewalPopup}
          setClosePopup={closeSubmitRenewalDialog}
          regionLooker={regionLooker}
        />

        <ConfirmationPopup
          customClass={"editConfirmation-popup"}
          title={"Confirmation"}
          type={"edit-confirmation"}
          successCallbackFn={changeColumnEditable}
          openPopup={openConfirmPopup}
          setClosePopup={closeConfirmDialog}
        >
          <p className="confirm-text">
            Base case materials are pre-defined by industry standards. Are you
            sure you want to edit these?
          </p>
        </ConfirmationPopup>

        <ConfirmationPopup
          customClass={"reviewalConfirmation-popup"}
          type={"reviewal-confirmation"}
          title={"Your assessment has been submitted for reviewal"}
          successCallbackFn={goToHome}
          openPopup={openReviewalConfirmPopup}
          setClosePopup={closeReviewalConfirmDialog}
        >
          <p className="confirm-text">
            Email notifications and review process are targeted for future
            release.
          </p>
        </ConfirmationPopup>

        <Backdrop open={workspaceDataSaveLoading}>
          <CircularWithValueLabel value={0} color="inherit" />
        </Backdrop>

        {saveClicked && workspaceDataSaveSuccess && (
          <SnackbarHandler
            severity={"success"}
            message={"Saved Successfully"}
          />
        )}
        {workspaceDataSaveError && (
          <SnackbarHandler
            severity={"error"}
            message={"Internal Server Error,Please try again"}
          />
        )}
      </Container>
    </>
  );
};

export default Workspace;
